import { renderInvalidatedColors } from './chart-util';
import {dashStylesHelper, roundLineJoinsHelper} from './util'
/**
 * Adds options for LINE charts.
 */
export function preRender(data, options) {
  let radius = 0;
  let hoverRadius = 2.5;
  const isVideoGroup = (options.id === 'video' || options.id === 'twitterVideo');
  const notVideoGroup = (options.id !== 'video' && options.id !== 'twitterVideo');
  if (options.markedDataPoints) {
    if (options.print)  !options.step ? radius = 1.25 : radius = 0;
    else {
      radius = !options.step ? 2.5 : 0;
      hoverRadius = !options.step ? 3.5 : 0;
    } 
  }
  const showOnHover = options.showTooltips;
  data.plotOptions.line = {
    clip: notVideoGroup,
    lineWidth: options.id === 'video' ? 11 : options.id === 'twitterVideo' ? 8 : 2,
    linecap: isVideoGroup ? 'round' : 'square',
    enableMouseTracking: options.interactive,
    states: {
      hover: {
        halo: {
          opacity: 1,
          size: hoverRadius
        },
        lineWidthPlus: 0
      }
    },
  };
  data.plotOptions.series = {
    marker: {
      symbol: 'circle',
      radius: radius,
      lineWidth: 0,
      lineColor: null,
      enabled: options.markedDataPoints,
      states: {
        hover: {
          enabled: showOnHover
        }
      }
    },
    dataGrouping: {
      enabled: !options.irregularDates
    }
  };
  if (__WSJ__) {
    if (options.size === 'print-wsj') {
      data.plotOptions.line.lineWidth = 1.5;
      data.plotOptions.line.linecap = 'round';
    }
  }
  return data;
}


export function postRender(highchart, options) {
  updateDashStyle(highchart, options); 
  roundLineJoins(highchart, options);
}

function updateDashStyle(highchart, options) {
  const paths = [...highchart.container.querySelectorAll('.highcharts-graph')];
  paths.forEach(path => dashStylesHelper(path, options.size))
}

function roundLineJoins(highchart, options) {
  const selector = 'g.highcharts-series-group g.highcharts-series path';
  const paths = highchart.container.querySelectorAll(selector);
  const isVideoGroup = (options.id === 'video' || options.id === 'twitterVideo');
  for (let i = 0; i < paths.length; i++) {
    roundLineJoinsHelper(paths[i], isVideoGroup)
  }
}

export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    renderInvalidatedColors(rendered, invalidated);
  }
}


// WEBPACK FOOTER //
// ./src/chart/inner/chart-line.js